var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "container", attrs: { type: "flex" } },
        [
          _c("h3", { staticClass: "title" }, [_vm._v("Filtros")]),
          _c(
            "el-row",
            { staticClass: "filter-row" },
            [
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Município:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        multiple: "multiple",
                        name: "municipio"
                      },
                      model: {
                        value: _vm.dados.municipios,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "municipios", $$v)
                        },
                        expression: "dados.municipios"
                      }
                    },
                    _vm._l(_vm.municipios, function(item) {
                      return _c("el-option", {
                        key: item.nome,
                        attrs: { label: item.nome, value: item.nome }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Situação:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        name: "status",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.dados.status,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "status", $$v)
                        },
                        expression: "dados.status"
                      }
                    },
                    _vm._l(_vm.situacao, function(item) {
                      return _c("el-option", {
                        key: item.nome,
                        attrs: { label: item.nome, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v("Tipo de pagamento:")
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        name: "status",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.dados.formaPagamento,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "formaPagamento", $$v)
                        },
                        expression: "dados.formaPagamento"
                      }
                    },
                    _vm._l(_vm.tipoPagamento, function(item) {
                      return _c("el-option", {
                        key: item.nome,
                        attrs: { label: item.nome, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "filter-row" },
            [
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v("Tipo de processo:")
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        name: "status",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.dados.tipoProcesso,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "tipoProcesso", $$v)
                        },
                        expression: "dados.tipoProcesso"
                      }
                    },
                    _vm._l(_vm.tipoProcesso, function(item) {
                      return _c("el-option", {
                        key: item.nome,
                        attrs: { label: item.nome, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "button-row" },
            [
              _c("span", { staticClass: "limpar", on: { click: _vm.limpar } }, [
                _vm._v("Limpar")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.filtrar } },
                [_vm._v("Filtrar")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec4881f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec4881f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/relatorios/components/FiltroVtn.vue
// module id = null
// module chunks = 